<form class="m-h-12 m-v-8"
  [formGroup]="form">
  <h3>{{ 'sigt.integration.rechercheGdf.form.recherche.titreCritereRecherche' | translate }}</h3>

  <mat-form-field class="d-flex tour-interactif-step-0-step-0">
    <mat-label>{{ 'sigt.integration.rechercheGdf.form.droitGdf.codeTypeDroit' | translate }}</mat-label>
    <mat-select formControlName="codeTypeDroit"
      multiple
      (closed)="selectTypeDroitChanged()"
      appFilterableMatSelect>
      <mat-option *ngFor="let cdTypeDroit of codeTypeDroitListeDeroulante"
        [value]="cdTypeDroit.codeTypeDroit">
        {{cdTypeDroit.descriptionTypeDroit}}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="form.controls.codeTypeDroit.errors?.required">
      {{messageApplication.obligatoireTypeDroit}}
    </mat-error>
  </mat-form-field>

  <mat-form-field class="d-flex tour-interactif-step-0-step-1">
    <mat-label>{{ 'sigt.integration.rechercheGdf.form.droitGdf.fin' | translate }}</mat-label>
    <mat-select formControlName="fin"
      multiple
      (closed)="selectFinChanged()"
      appFilterableMatSelect>
      <mat-option *ngFor="let fin of finsListeDeroulante"
        [value]="fin.codeFin">
        {{fin.descriptionFin}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field class="d-flex tour-interactif-step-0-step-2">
    <mat-label>{{ 'sigt.integration.rechercheGdf.form.droitGdf.statutDroit' | translate }}</mat-label>
    <mat-select formControlName="statutDroit"
      multiple
      (closed)="selectStatutChanged()">
      <mat-option *ngFor="let statutDroit of statutListeDeroulante"
        [value]="statutDroit.codeStatut">
        {{statutDroit.nomStatut}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <h3>
    {{'sigt.integration.rechercheGdf.form.droitGdf.localisation'|translate}}<span class="required">*</span>
  </h3>

  <mat-form-field class="d-flex tour-interactif-step-0-step-3">
    <mat-label>{{ 'sigt.integration.rechercheGdf.form.droitGdf.municipalite' | translate }}</mat-label>
    <mat-select formControlName="municipalite"
      multiple
      appFilterableMatSelect>
      <mat-option *ngFor="let municipalite of municipaliteListeDeroulante"
        [value]="municipalite.codeMunicipalite">
        {{municipalite.nomMunicipalite}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field class="d-flex tour-interactif-step-0-step-4">
    <mat-label>{{ 'sigt.integration.rechercheGdf.form.droitGdf.mrc' | translate }}</mat-label>
    <mat-select formControlName="mrc"
      multiple
      (closed)="selectMrcChange()"
      appFilterableMatSelect>
      <mat-option *ngFor="let mrc of mrcListeDeroulante"
        [value]="mrc.codeMrc">
        {{mrc.nomMrc}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field class="d-flex tour-interactif-step-0-step-5">
    <mat-label>{{ 'sigt.integration.rechercheGdf.form.droitGdf.regionAdmin' | translate }}</mat-label>
    <mat-select formControlName="regionAdministrative"
      multiple
      (closed)="selectRegionChange()"
      appFilterableMatSelect>
      <mat-option *ngFor="let regionAdministrative of regionsAdministrativeListeDeroulante"
        [value]="regionAdministrative.codeRegion">
        {{regionAdministrative.nomRegion}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <div class="boutons-en-grille">
    <button mat-raised-button
      type="button"
      class="clear-search-button tour-interactif-gdf-reinitialiser"
      (click)="initialiserChamps()">
      {{ 'sigt.global.boutons.reinitialiser' | translate }}
    </button>

    <button mat-raised-button
      class="search-button tour-interactif-gdf-rechercher"
      [disabled]="!form.valid"
      (click)="rechercher()"
      color="primary">
      {{ 'sigt.global.boutons.rechercher' | translate }}
    </button>
  </div>
</form>
